/**
 * i18n configuration — CONFILEX FR/EN.
 *
 * Source unique de vérité pour la traduction de l'interface.
 * Détection automatique de la langue préférée du navigateur, persistance
 * localStorage + endpoint backend pour les utilisateurs connectés.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";

const SUPPORTED = ["fr", "en"];
const FALLBACK = "fr";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en } },
    fallbackLng: FALLBACK,
    supportedLngs: SUPPORTED,
    nonExplicitSupportedLngs: true,  // "en-US" → "en"
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "confilex-lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

// Synchronise <html lang="..."> à chaque changement
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lng?.split("-")[0] || FALLBACK);
  }
});

export default i18n;
export { SUPPORTED, FALLBACK };
